import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiLink = {
  defaultProps: { underline: 'hover' },
} satisfies Components<Theme>['MuiLink'];
